<avi-alert-group
    [alerts]="warningList"
    class="full-modal-config-warnings"
    #alertGroup
></avi-alert-group>
